import { tokens } from '@news-mono/design-tokens'
import { TheNightlySections } from '@west-australian-newspapers/publication-types'
import { BaseSectionValues } from '.'

export type TheNightlySection = keyof typeof TheNightlySections

export interface TheNightlySectionValues extends BaseSectionValues {
    backgroundColor: string
}

export type TheNightlySectionProps = {
    [section in TheNightlySection]: TheNightlySectionValues
}

const { section, uplate } = tokens.thenightly.colors.palette

export const theNightlySectionDefinitions: TheNightlySectionProps = {
    default: {
        primaryColor: uplate.default,
        backgroundColor: uplate.light,
    },
    australia: {
        primaryColor: section.australia.default,
        backgroundColor: section.australia[97],
    },
    opinion: {
        primaryColor: section.opinion.default,
        backgroundColor: section.opinion[97],
    },
    world: {
        primaryColor: section.world.default,
        backgroundColor: section.world[97],
    },
    politics: {
        primaryColor: section.politics.default,
        backgroundColor: section.politics[97],
    },
    business: {
        primaryColor: section.business.default,
        backgroundColor: section.business[97],
    },
    sport: {
        primaryColor: section.sport.default,
        backgroundColor: section.sport[97],
    },
    society: {
        primaryColor: section.society.default,
        backgroundColor: section.society[97],
    },
    culture: {
        primaryColor: section.culture.default,
        backgroundColor: section.culture[97],
    },
    lifestyle: {
        primaryColor: section.lifestyle.default,
        backgroundColor: section.lifestyle[97],
    },
}
